import 'jquery-countdown';
import moment from 'moment';

const $countDown = $('.js-dsc-count');
const startDate = ('date' in beaches_app.page.countdown) ? beaches_app.page.countdown.date : '2010-10-10';
const date = moment(startDate, 'YYYY-MM-DD').add(1, 'days');

$countDown.countdown(date.format('YYYY-MM-DD'), event => {
  $(event.currentTarget).html(event.strftime(''
    + '<div><span class="count-digits">%d</span> days</div>'
    + '<div><span class="count-digits">%H</span> hours</div>'
    + '<div><span class="count-digits">%M</span> min.</div>'
    + '<div><span class="count-digits">%S</span> sec.</div>'));
});
